import type { GetIssueAuditByIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import { GetIssueAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

import type { AuditLogQueryResult } from './auditLogQueryResult';

type UseGetIssueAuditByIdArgs = {
  id: string;
};

export const useGetIssueAuditById = createQueryHook<
  UseGetIssueAuditByIdArgs,
  GetIssueAuditByIdResponseRow[],
  AuditLogQueryResult<'issue_audit', GetIssueAuditByIdResponseRow, 'Details'>
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getIssueAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ issue_audit: data }),
  graphqlDocument: GetIssueAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
